import React from 'react'
import { ClipLoader } from 'react-spinners';

export default function Spinners() {
  return (
    <div className="loading-spinner"><ClipLoader color="#f5752b" size={90}/></div>
  )
}
